var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 27,
    height: 27,
    viewBox: "0 0 27 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.4993 0C6.04096 0 0 6.04096 0 13.4993C0 20.9577 6.04096 26.9987 13.4993 26.9987C20.9577 26.9987 26.9987 20.9577 26.9987 13.4993C26.9987 6.04096 20.9577 0 13.4993 0ZM14.8493 20.249H12.1494V12.1494H14.8493V20.249ZM14.8493 9.44954H12.1494V6.74967H14.8493V9.44954Z",
    fill: "#737C8A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info-icon.706db0629e868ae413e809c7ab507dd1.svg";
export { ForwardRef as ReactComponent };